"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Permission = void 0;
const chat_1 = require("./chat");
const habitat_1 = require("./habitat");
const map_1 = require("./map");
const misc_1 = __importDefault(require("./misc"));
const schedule_1 = require("./schedule");
const zoo_1 = require("./zoo");
// TODO - export Permission type
exports.Permission = Object.assign({ Habitat: habitat_1.Habitat, Map: map_1.Map, Chat: chat_1.Chat, Schedule: schedule_1.Schedule, Zoo: zoo_1.Zoo }, misc_1.default);
